import React, { Component } from 'react';
import Code from 'components/Code';

export default class Leave extends Component {
    render() {
        const { pkDelivery } = this.props;
        return (
            <div>
                <div style={{height:'0.4rem'}}></div>
                <Code noticePK={ pkDelivery }></Code>
                <div style={{height:'0.4rem'}}></div>
            </div>
        )
    }
}
